import React, { useState } from 'react';
import { Dropdown, Button, Spinner } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { getTransactions } from 'helpers/http/common';

// Helper function to strip HTML tags
const stripHtmlTags = (html: string) => {
  if (!html) return '';
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

const EXPORT_OPTIONS = {
  alltime: 'All time',
  today: 'Today',
  thisweek: 'This week',
  thismonth: 'This month',
  thisyear: 'This year',
  last3years: 'Last 3 years',
};

const DownloadExcel = () => {
  const [isExporting, setIsExporting] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState('alltime');

  const handleExport = async (filter: string) => {
    setIsExporting(true);
    setSelectedFilter(filter);

    try {
      const response = await getTransactions({
        page: 1,
        limit: 1000,
        activeFilter: filter,
        isExport: true,
      });

      if (response?.status && response?.data?.transactionData) {
        const exportData = response.data.transactionData.map((item: any) => ({
          'Transaction ID': item.charge_trans_id,
          'Payment Type': item.payment_type,
          Amount: item.amount,
          Currency: item.currency,
          Status: item.status,
          Date: moment(item.date_created).format('MMM DD, YYYY'),
          'Fee Amount': item.fee_amount,
          'Fee Percentage': item.fee_percentage,
          'Stripe Fee': item.stripe_fees,
          'Client/Freelancer': `${item.first_name} ${item.last_name}`,
          'Job Title': item.job_title,
          'Milestone Amount': item.milestone_amount,
          'Milestone Description': stripHtmlTags(item.milestone_description),
        }));

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Transactions');

        const fileName = `transactions_${filter}_${moment().format(
          'YYYY-MM-DD'
        )}.xlsx`;
        XLSX.writeFile(wb, fileName);
      }
    } catch (error) {
      console.error('Export failed:', error);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Dropdown>
      <Dropdown.Toggle variant="primary" disabled={isExporting}>
        {isExporting ? (
          <>
            <Spinner animation="border" size="sm" className="me-2" />
            Exporting {EXPORT_OPTIONS[selectedFilter]}...
          </>
        ) : (
          'Export Excel'
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {Object.entries(EXPORT_OPTIONS).map(([key, label]) => (
          <Dropdown.Item
            key={key}
            onClick={() => handleExport(key)}
            disabled={isExporting}
          >
            {label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DownloadExcel;
